export const TOPIC_PANEL_TYPES = {
  TableauReport: 9,
  TableauReportPage: 10,
};

export const isTableauPanel = (panelType: number) =>
  Object.values(TOPIC_PANEL_TYPES).indexOf(panelType) !== -1;
